export default __webpack_public_path__ + "static/media/storm.78644dc9.svg";